import {
  type AsyncStateObject, type Action, type GoalListData
} from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, GOAL_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<GoalListData | null> = {
  data: null,
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}

const getGoalByIdReducer = (
  state = INITIAL_STATE,
  action: Action<GoalListData>
): AsyncStateObject<GoalListData | null> => {
  switch (action.type) {
    case GOAL_ACTIONS.GET_GOAL_BY_ID + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case GOAL_ACTIONS.GET_GOAL_BY_ID + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case GOAL_ACTIONS.GET_GOAL_BY_ID + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: null,
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case GOAL_ACTIONS.GET_GOAL_BY_ID + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default getGoalByIdReducer
